import React,{useState} from "react";
import { NavLink } from "react-router-dom";

import { Grid } from "@material-ui/core";

import useStyles from "./style";

const Open = () => {
  const classes = useStyles();
//   const [page1, setPage1] = useState(true);
//   const [page2, setPage2] = useState(false);
//   const [style1, setStyle1] = useState({
//     color: "#fefff0",
//     background: "#547972",
//   });
//   const [style2, setStyle2] = useState({
//     color: "#547972",
//     background: "#fefff0",
//   });
//   const [stylePage1, setStylePage1] = useState(style1);
//   const [stylePage2, setStylePage2] = useState(style2);

//   const handle1 = () => {
//     setPage1(true);
//     setStylePage1(style1);
//     if (page2) {
//       setStylePage2(style2);
//       setPage2(false);
//     }
//   };

//   const handle2 = () => {
//     setPage2(true);
//     setStylePage2(style1);
//     if (page1) {
//       setStylePage1(style2);
//       setPage1(false);
//     }
//   };
  return (
    <>
      <Grid className={classes.options}>
        <Grid>
          <NavLink
            // style={stylePage1}
            // onClick={() => handle1()}
            to="/"
            className={classes.links}
          >
            Words Dictionary
          </NavLink>
        </Grid>
        <Grid>
          <NavLink
            // style={stylePage2}
            to="/translater"
            // onClick={() => handle2()}
            className={classes.links}
          >
            Translater
          </NavLink>
        </Grid>
      </Grid>
    </>
  );
};

export default Open;
